/**
 * Main menu dialog for mobile devices
 *
 * @author bgr
 */
import { html } from "lit-html";
import { Base } from "../../../shared/components/dialogs/Base";
import { pageType } from "@escapio/portal/state/pageType";
import { onChangeCurrency } from "../../state/travelData";
import { track } from "../../tracker/EventTracker";
import "./Menu";

export class Dialog extends Base {
	constructor() {
		super();
		this.node.classList.add("main-menu-dialog");
		onChangeCurrency(() => {
			this.hide();
		});
	}

	show() {
		super.show();
		track("Header", "Hamburger", "öffnen - " + pageType);
	}

	hide() {
		super.hide();
		track("Header", "Hamburger", "schließen - " + pageType);
	}

	getTemplateHeaderMiddle() {
		return html`<span class="fa fa-bars"></span>`;
	}

	getTemplateContent() {
		return html`<esc-menu context="Header"></esc-menu>`;
	}
}
